export default __webpack_public_path__ + "static/media/1.cbca40a3.png";